module.exports = __webpack_public_path__ + "img/pexels-ekaterina-bolovtsova-6077326.jpg.990ff6aa.png";